import { ContentType } from '../institucional/content';

export const privacyPolicyContent: ContentType[] = [
  {
    type: 'grid',
    sections: [
      {
        id: '1',
        __component: 'sections.toppage',
        heading: 'Políticas de Privacidade',
        description: 'Versão revisada em outubro/2024.',
      },
      {
        id: '2',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: 'Informações Gerais',
        items: [
          <>
            A FM Impressos Personalizados Ltda., pessoa jurídica de direito
            privado, estabelecida na Rua João Ferreira de Camargo, 714, Tamboré,
            Barueri, SP, CEP 06460-060, devidamente inscrita no CNPJ/MF sob o nº
            13.555.994/0001-54(daqui por diante denominada PRINTI ou nós),
            proprietária do site{' '}
            <a target="_blank" href="https://www.printi.com.br/">
              www.printi.com.br
            </a>{' '}
            (“Site”), estabelece, através da presente Política de Privacidade
            (“Política”), as diretrizes e os procedimentos para o tratamento de
            dados pessoais em suas atividades de prestação de serviços de
            impressão digital (“Serviços”), na qualidade de controladora destes
            dados, em cumprimento com o disposto na Lei Geral de Proteção de
            Dados Pessoais, a Lei nº 13.709 de 2018 (“LGPD”).
          </>,
          <>
            Ao navegar, cadastrar-se ou realizar pedidos e compras de Serviços
            em nosso Site ou em nossos canais de atendimento, como e-mail e
            telefone (em conjunto, “Plataformas”), você (“Você” ou “Usuário”),
            seja na sua atuação como pessoa física ou na qualidade de
            representante legal de pessoa jurídica cadastrada (neste caso,
            vinculando esta empresa aos termos e condições desta Política),
            declara expressamente aceitar e concordar com os nossos{' '}
            <a href="/termos-de-uso/">Termos de Uso</a> e esta Política de
            Privacidade.
          </>,
          'A PRINTI está comprometida em proteger sua privacidade. Como a coleta e o processamento de alguns dados pessoais relacionados a Você (“Dados Pessoais”) podem ser necessários e importantes para a prestação dos nossos Serviços, processaremos seus Dados Pessoais conforme determinado nesta Política, observando a legislação brasileira aplicável.',
        ],
      },
      {
        id: '3',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '1. Dados pessoais que tratamos',
        items: [
          'A PRINTI poderá coletar e processar os seguintes Dados Pessoais relacionados a Você (na qualidade de pessoa física ou representante de pessoa jurídica), com o objetivo de fornecer os nossos Serviços, sem prejuízo de outras que venham a ser necessárias:',
          <>
            <ul>
              <li>
                Informações pessoais: nome completo, e-mail e telefone, endereço
                de entrega e endereço de cobrança, CPF, Data de Nascimento,
                dados bancários necessários para verificar os pagamentos do
                Usuário, histórico de compras, dados de compras.
              </li>
              <br></br>
              <li>
                Informação pessoal para representantes de pessoas jurídicas:
                nome completo, e-mail, telefone, empresa e site da empresa, CPF.
              </li>
              <br></br>
              <li>
                Outras informações de identificação: identificadores
                específicos, tais como ID de usuário do Site, nome de usuário,
                endereço IP, data e hora de acesso como Usuário no Site, data e
                hora dos pagamentos realizados pelo Usuário, bem como quaisquer
                outros Dados Pessoais que você decida ou precise revelar ao
                longo do seu relacionamento conosco.
              </li>
            </ul>
          </>,
          'Nós não coletaremos ou utilizaremos dados sensíveis, a menos que Você nos dê seu prévio consentimento, específico e destacado para uma finalidade determinada e previamente informada, ou caso tenhamos que utilizar tais dados para atendimento da legislação aplicável. Ao cadastrar uma Conta, você se compromete em fornecer dados completos, precisos, atualizados e verdadeiros. Em caso de alteração de qualquer um dos dados cadastrais informados, Você deverá atualizá-los de imediato.',
          'Se qualquer informação fornecida pelo Usuário for falsa, incorreta, desatualizada ou incompleta, ou caso a PRINTI tenha razões suficientes e fundamentadas para suspeitar do acima exposto, a PRINTI terá o direito de suspender ou cancelar imediatamente a solicitação de compra do Serviço realizado pelo Usuário, bem como qualquer futura solicitação de Serviço ou parte dele, independente de notificação.',
        ],
      },
      {
        id: '4',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '2. Finalidades do uso de seus dados pessoais',
        items: [
          'Nós coletamos e utilizamos seus Dados Pessoais para os seguintes fins e da seguinte forma, sem prejuízo de outras atividades legítimas que sejam permitidas pela legislação aplicável:',
          <>
            <ul>
              <li>
                Dar suporte aos nossos Serviços e realizar as operações gerais
                de negócios, conforme aplicável, garantindo o bom e correto
                funcionamento das Plataformas;
              </li>
              <br></br>
              <li>
                Gerir e processar as suas compras, incluindo o processamento dos
                seus pedidos, e para fornecer os Serviços que nos solicitou;
              </li>
              <br></br>
              <li>
                Atender às suas solicitações, dar suporte aos Usuários, tal como
                criação de Conta, compras, dúvidas e demais contatos referentes
                aos nossos Serviços e Plataformas;
              </li>
              <br></br>
              <li>Processar pagamentos e fornecer orçamentos;</li>
              <br></br>
              <li>
                Recuperar o carrinho de compras abandonado, bem como para enviar
                a confirmação de uma ordem de compra;
              </li>
              <br></br>
              <li>Administrar sua conta e gerenciar nossos Serviços;</li>
              <br></br>
              <li>
                Embasar nossa análise para melhorias e aprimoramentos dos nossas
                Plataformas, incluindo melhorias em seu conteúdo e na
                personalização ou customização do layout, dentro de sua
                experiência de nossos Serviços;
              </li>
              <br></br>
              <li>
                Garantir a segurança durante a prestação dos nossos Serviços nas
                Plataformas, incluindo sua navegação no Site, detectando,
                combatendo e prevenindo fraudes e uso indevido de seus Dados
                Pessoais;
              </li>
              <br></br>
              <li>
                Cumprir e atender à legislação aplicável, obrigações legais e
                regulatórias, bem como para proteger nossos direitos e atender
                nossos legítimos interesses para prestação dos Serviços;
              </li>
              <br></br>
              <li>
                Para falarmos com você, enviando comunicações referentes à
                compra ou venda de produtos e aos Serviços, conforme aplicável,
                bem como comunicações que contenham novidades, informações e
                atualizações sobre os nossos Serviços e demais que possam ser do
                seu interesse;
              </li>
              <br></br>
              <li>
                Para enviar newsletter ou materiais de marketing, assim como
                pesquisas sobre os produtos e Serviços contratados pelos
                Usuários, desde que este envio observe a legislação aplicável.
              </li>
              <br></br>
              <li>
                Gerar estatísticas agregadas sobre os Usuários, nas quais será
                mantido o anonimato dos Dados Pessoais.
              </li>
            </ul>
          </>,
        ],
      },
      {
        id: '5',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '3. Bases legais para o processamento de seus dados pessoais',
        items: [
          <>
            <ul>
              <li>
                Execução contratual e procedimentos preliminares relacionados ao
                contrato;
              </li>
              <br></br>
              <li>Obrigação legal ou regulatória;</li>
              <br></br>
              <li>Atender ao nosso legítimo interesse ou ao de terceiros;</li>
              <br></br>
              <li>
                Exercício regular de direitos em processo judicial,
                administrativo ou arbitral; ou
              </li>
              <br></br>
              <li>
                Seu consentimento expresso e informado para finalidades
                específicas.
              </li>
            </ul>
          </>,
        ],
      },
      {
        id: '6',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '4. Compartilhamento de seus dados pessoais',
        items: [
          'O eventual compartilhamento será realizado exclusivamente para a prestação dos Serviços. Nós não divulgaremos, venderemos ou disponibilizaremos seus Dados Pessoais fora do escopo das finalidades descritas nesta Política e/ou em desacordo com a legislação aplicável. Na medida permitida por lei e mediante o uso da base legal aplicável, os Dados Pessoais coletados podem ser compartilhados com:',
          <>
            <ul>
              <li>
                O grupo PRINTI: Empresas do grupo da PRINTI, seus associados e
                afiliados. Os Dados Pessoais podem ser divulgados para (i)
                auxiliar a detectar e prevenir possíveis atos ilegais, violação
                de nossas políticas, fraude ou violações de segurança de dados;
                e (ii) orientar a tomada de decisões sobre os nossos Serviços.
              </li>
              <br></br>
              <li>
                Prestadores de serviços e terceiros: Prestadores de serviços
                contratados, com o objetivo de nos auxiliar em nossas operações
                comerciais (incluindo, por exemplo, prestadores de serviços de
                produção e personalização de produtos, suporte virtual,
                processadores de pagamento, armazenamento de dados, provedores
                de serviços de entrega de produtos, investigações de fraude,
                cobrança de contas, processamento de pagamentos e análises,
                suporte técnico e operações das Plataformas). A PRINTI exigirá,
                desses terceiros, o mesmo grau de cuidado por ela praticado para
                tratamento dos dados.
              </li>
              <br></br>
              <li>
                Autoridades responsáveis pelo cumprimento da lei: Autoridades
                encarregadas do cumprimento da lei, agências governamentais ou
                terceiros autorizados, em resposta a uma solicitação verificada
                que esteja relacionada a uma investigação criminal ou a uma
                atividade supostamente ilegal, ou a qualquer outra atividade que
                possa expor a PRINTI, Você ou qualquer outro usuário a uma
                responsabilidade jurídica.
              </li>
              <br></br>
              <li>
                Troca de controle e reestruturação societária: Terceiros, no
                caso de uma fusão, cisão, incorporação, transformação,
                aquisição, alteração de controle ou qualquer forma de
                reestruturação societária da PRINTI.
              </li>
              <br></br>
              <li>
                Redes de publicidade: Terceiros relacionados a serviços de
                coleta de dados, notificação, análise, serviços de marketing e
                publicidade dos nossos Serviços. Esses terceiros podem
                visualizar, editar ou configurar suas próprias tecnologias de
                rastreamento ou cookies.
              </li>
              <br></br>
              <li>
                Transferência Internacional de Dados Pessoais. Tendo em vista a
                possibilidade de operação em diversos países e a possibilidade
                de sistemas de computador em sede global, incluindo serviços de
                armazenamento de dados em nuvem, nós ou terceiros relacionados
                podemos armazenar e processar seus Dados Pessoais em outras
                jurisdições.<br></br> Tomaremos as medidas necessárias para
                garantir que seus Dados Pessoais recebam um nível adequado de
                proteção conforme exigido pela lei aplicável, seja através do
                uso das cláusulas-padrão contratuais estabelecidas pela lei
                aplicável ou por meio de outras salvaguardas, conforme
                determinado pela LGPD ou pela autoridade nacional de proteção de
                dados brasileira. Na falta de regulamentação específica e
                complementar sobre o tema no país, podemos adotar modelos de
                cláusula e nos basearmos em modelos ou instruções utilizadas no
                regulamento europeu.
              </li>
            </ul>
          </>,
        ],
      },
      {
        id: '7',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '5. Retenção de dados e duração de tratamento',
        items: [
          'Os seus Dados Pessoais serão armazenados pelo tempo legalmente exigido ou necessário para as finalidades de processamento e/ou para a conclusão da prestação dos Serviços aqui descritos, salvo se Você requerer a eliminação de seus Dados Pessoais tratados mediante seu consentimento, que será atendido no tempo legalmente permitido, salvo as retenções necessárias e permitidas por lei.',
        ],
      },
      {
        id: '8',
        __component: 'sections.textblog',
        heading: '6. Segurança',
        headingSize: 'large',
        items: [
          <>
            Os Dados Pessoais que você nos fornece são coletados, usados e
            protegidos em conformidade com os maiores padrões de segurança e
            confidencialidade, e utilizados apenas para as finalidades para os
            quais foram coletados, conforme descrito nesta Política. Nós nos
            obrigamos a implementar medidas técnicas e organizacionais adequadas
            à proteção de seus Dados Pessoais contra o processamento ilegal ou
            não autorizado ou perda acidental, destruição, danos, roubo,
            utilização ou divulgação, quando os seus Dados Pessoais são
            processados sob o nosso controle, em conformidade com a legislação
            aplicável e as melhores práticas. <br></br> O Usuário se obriga a
            notificar imediatamente a PRINTI sobre qualquer uso não autorizado
            de seu login e senha no Site ou qualquer violação de segurança de
            seu conhecimento. O Usuário também concorda em não deixar seu
            cadastro pessoal aberto no computador após entrar com seu endereço
            eletrônico no Site, evitando, assim, o uso desautorizado por
            terceiros.
          </>,
        ],
      },
      {
        id: '9',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '7. Menores de 18 anos',
        items: [
          <>
            O uso e cadastro no Site, bem como o pedido por meio das demais
            Plataformas é exclusivo para usuários acima de 18 (dezoito) anos.
            Caso o acesso seja feito por menores de idades e sujeitos incapazes
            de praticar atos da vida civil, o cadastro será rejeitado. Menores
            de idade que estejam interessados nos serviços da PRINTI deverão
            pedir a intermediação dos seus pais ou representantes legais.{' '}
            <br></br> Nós solicitamos que você, menor de idade, não submeta
            quaisquer Dados Pessoais em nosso Site. Ao tomar conhecimento da
            violação do exposto, a PRINTI irá imediatamente deletar seus Dados
            Pessoais. Nós nos isentamos de qualquer responsabilidade com relação
            a Dados Pessoais submetidos em desrespeito ao disposto na presente
            cláusula, na máxima extensão do permitido pela lei aplicável e sem
            limitação de qualquer outra disposição desta Política de
            Privacidade.
          </>,
        ],
      },
      {
        id: '10',
        __component: 'sections.textblog',
        heading: '8. Comunicações da Printi',
        headingSize: 'large',
        items: [
          <>
            Nós poderemos enviar comunicações periódicas a Você, tais como
            comunicações para dar suporte aos nossos Serviços e gerenciar suas
            compras realizadas nas Plataformas. <br></br> Nós também poderemos
            enviar comunicações periódicas a Você que contenham novidades,
            informações e atualizações sobre os nossos Serviços e outras
            comunicações que possam ser do seu interesse, mediante seu
            consentimento específico no item “Quero receber ofertas exclusivas e
            novidades por e-mail” No entanto, caso não tenha interesse, Você
            poderá cancelar essas comunicações a qualquer momento seguindo as
            instruções de exclusão de cadastramento (“Opt-Out”) indicadas ao
            final das comunicações periódicas enviadas a Você.
          </>,
        ],
      },
      {
        id: '11',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '9. Direitos dos titulares de dados pessoais',
        items: [
          'A LGPD garante diversos direitos aos titulares de dados, principalmente conforme disposto no seu Artigo 18. Na medida em que sejam aplicáveis e mediante seu requerimento, a PRINTI atenderá suas solicitações nos prazos e termos previstos em regulamento aplicável:',
          <>
            <ul>
              <li>
                Direito de Confirmação e Acesso: Você pode requerer a
                confirmação da existência de tratamento e o acesso aos seus
                Dados Pessoais. Esse direito pode ser exercido para acessar e
                obter uma cópia dos seus Dados Pessoais sob nosso controle, bem
                como sobre informação sobre as entidades públicas e privadas com
                as quais nós realizamos uso compartilhado de informações.
              </li>
              <br></br>
              <li>
                Direito de Retificação: Refere-se ao seu direito de correção de
                informações incompletas, inexatas ou desatualizadas. Você poderá
                atualizar e corrigir seus Dados Pessoais a qualquer momento,
                acessando sua conta ou entrando em contato conosco no canal
                indicado ao final desta Política. Encorajamos Você a sempre
                atualizar ou corrigir seus Dados Pessoais em nossos cadastros.
              </li>
              <br></br>
              <li>
                Direito de Exclusão: Você pode requerer a anonimização, bloqueio
                ou eliminação de Dados Pessoais desnecessários, excessivos ou
                tratados em virtude exclusiva do seu consentimento, caso
                realizados em desconformidade com a LGPD.
              </li>
              <br></br>
              <li>
                Direito de Portabilidade de Dados: Você pode querer a
                portabilidade de seus Dados Pessoais a outro fornecedor de
                produtos ou serviços, mediante requisição expressa e observados
                os nossos segredos comercial e industrial, de acordo com a
                regulamentação e lei aplicável.
              </li>
              <br></br>
              <li>
                Direitos Ligados ao Consentimento: Caso o tratamento de seus
                Dados Pessoais seja baseado no seu consentimento, você possui o
                direito de não o fornecer ou revogar. Você também possui o
                direito de solicitar a eliminação dos dados pessoais tratados
                com o consentimento, observadas as exceções legais. No entanto,
                é importante estar ciente de que, se optar por eliminar os Dados
                Pessoais tratados apenas com base no consentimento, a PRINTI
                poderá ficar impossibilitada de assegurar a continuidade da sua
                prestação de Serviços aos Usuário. Caso Você opte por retirar o
                seu consentimento, Você receberá informações sobre as potenciais
                consequências desta revogação.
              </li>
              <br></br>
              <li>
                Direito de Revisão: Você tem direito de solicitar a revisão de
                decisões tomadas unicamente com base em tratamento automatizado
                de dados pessoais que afetem seus interesses, caso utilizadas
                por nós, incluídas as decisões destinadas a definir o seu perfil
                pessoal, profissional, de consumo e de crédito ou os aspectos de
                sua personalidade, caso aplicável.
              </li>
              <br></br>
              <li>
                Outros Direitos: Você possui, ainda, o direito de se opor ao
                tratamento de seus Dados Pessoais em caso de descumprimento da
                lei aplicável. Você possui o direito de receber informações
                sobre quem são os terceiros com os quais nós realizamos o uso
                compartilhado dos Dados Pessoais, além do direito de peticionar
                perante a Autoridade Nacional e perante organismos de defesa do
                consumidor.
              </li>
            </ul>
          </>,
        ],
      },
      {
        id: '12',
        __component: 'sections.textblog',
        heading: '10. Cookies e tecnologias de restreamento',
        headingSize: 'large',
        items: [
          <>
            Em nosso Site, nós usamos cookies e outras tecnologias de
            rastreamento para monitorar o uso do Site e nossos Serviços. Saiba
            mais em <a href="/politicas-de-cookies/">Política de Cookies</a>
          </>,
        ],
      },
      {
        id: '13',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '11. Alterações desta política',
        items: [
          'Nós nos reservamos ao direito de, a qualquer momento e a nosso exclusivo critério, modificar qualquer parte dos termos desta Política que não afete materialmente seus direitos ou obrigações aqui estipuladas. Qualquer versão atualizada desta Política supera e substitui qualquer versão anterior no momento da publicação, e a versão anterior não será mais vigente e não terá mais efeitos, a não ser que o contrário seja especificamente declarado. Alterações significativas e materiais desta Política serão previamente informadas a Você.',
        ],
      },
      {
        id: '14',
        __component: 'sections.textblog',
        headingSize: 'large',
        heading: '12. Entre em contato conosco',
        items: [
          <>
            Em caso de dúvidas sobre nossa Política, nossas práticas, ou caso
            deseje entrar em contato com a PRINTI para atualizar ou corrigir
            qualquer um de seus Dados Pessoais ou demais informações cadastradas
            ou exercer seus direitos, nós estaremos disponíveis através do nosso{' '}
            <a
              target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSeLftwFpKpLln17hBAhswIaYvNkKaZzpQlCXhnvC8pV9g44Fw/viewform"
            >
              formulário
            </a>
            , por meio do nosso encarregado no tratamento de dados chamado
            Daniel Rocha dos Santos.
          </>,
        ],
      },
    ],
  },
];
